import { CategoriesReducerState } from './categoriesReducer.types';

export const CATEGORIES_REDUCER_INITIAL_STATE = Object.freeze<CategoriesReducerState>({
    hasReceivedCategories: {},
    hasReceivedAllCategories: false,
    categories: {},
});
